
import { faPython,faHtml5, faPhp,faLinux,faCloudflare} from '@fortawesome/free-brands-svg-icons';
import { faDatabase,faServer,faUserCog ,faShieldAlt ,faKey,faLock,faTools,faChartLine,faCode, faGlobe,faChartPie ,faCloud, faTruck,faNetworkWired, faProjectDiagram,faTerminal,faBullhorn ,faBoxes,faWallet,faUsers,faUserSecret, faShareAltSquare,faCubes, faBolt, faCodeBranch} from '@fortawesome/free-solid-svg-icons';

const courses = {
  python: {
  name: "Python",
  description: "Learn Python from basics to intermediate:  data types, control flow, functions, file handling, OOP, modules, and libraries like datetime and regular expressions.",
  className: "python",
  icon: faPython,
  fee: 15000,
  duration: "3 months",
  prerequisites: [
    "Basic programming concepts",
    "Familiarity with Object-Oriented Programming (OOP)",
    "Understanding of data structures and algorithms",
  ],
 content: [
    "Installing Python on Windows/Linux/Mac OS",
    "Using Python Interpreter and Script Execution",
    "Structuring Code with Indentation and Editors",
    "Variables, Identifiers, and Naming Conventions",
    "Data Structures: Lists, Tuples, Sets, Dictionaries",
    "Input and Output Handling",
    "Control Flow: if/else, loops, range(), break/continue",
    "Functions: Default, Keyword, Arbitrary Arguments",
    "File Handling: Reading and Writing Files",
    "Error Handling: Syntax Errors, Exceptions, try/except",
    "Modules: Creating, Importing, and Executing Modules",
    "Object-Oriented Programming: Classes, Objects, Methods",
    "Advanced Modules: Regular Expressions, datetime, Excel Handling, GUI, and Web Scraping",
  ],
  targetAudience: "This course is ideal for beginners and intermediate developers looking to master Python programming for application development, data manipulation, and automation."
}

,
 php: {
    name: "PHP",
    description: "Master PHP for backend development. Learn web architecture, CRUD operations, form handling, sessions, cookies, database integration, and advanced PHP features.",
    className: "php",
    icon: faPhp,
    fee: 15000,
    duration: "3 months",
    prerequisites: [
      "Basic knowledge of HTML and CSS",
      "Understanding of programming fundamentals",
    ],
     content: [
      // Initial PHP course topics
      "Web Architecture",
      "Overview of PHP Platform",
      "Origins of PHP in the Open Source Community",
      "Why We Use PHP",
      "PHP Strengths",
      "Main Competitors: PERL, ASP.NET, JavaServer Pages",
      "Availability Across Multiple Platforms",
      "Installing PHP as a Module for Apache Web Server",
      "CRUD Operations - Accessing Command Line Arguments in PHP",
      "Generating Web Pages Dynamically Using PHP",
      "Retrieving and Manipulating Web Data",
      "Personalizing Content with Sessions and Cookies",
      "Tracking User Navigation",
      "Using Regular Expressions for Strong Validation",
      "Exception Handling in PHP",
      "Integrating Database Content into Web Pages",
      "PDF Document Generation",
      "PHP Language Building Blocks - Comparing PHP with Other Web Scripting Languages",
      "PHP Installation and Setup",
      "PHP Delimiters",
      "Variable Initialization",
      "PHP Data Types and Constants",
      "PHP Operators",

      // Conditional statements and loops
      "Conditional Statements: If-else, If-else-if-else, Nested If, Switch Case",
      "Jump Statements (Break, Continue, Exit)",
      "Looping (Iteration): For Loop, While Loop, Do-While Loop, Nested Loop",

      // Arrays

      "How to Use Arrays: Numerically Indexed, Associative (Non-Numerically Indexed), and Multidimensional Arrays",
      "Array Sorting and Manipulation",
      
      // User Input and Functions
      "Manipulating User Input: Retrieving Form Data with $_POST, $_GET, and $_REQUEST Arrays",
      "Preserving Data in Form Inputs",
      "Reusing Code and Functions: Defining Functions, Using Parameters, Understanding Scope, Returning Values",
      "Call by Value & Call by Reference",
      "Using Require() and Include()",
      "Array, String, Math, Date Functions",

      // File Uploading and Downloading
      "File Uploading Concepts and Multiple File Upload",
      "Downloading Files from Server Using Header",
      
      // String Manipulation and Regular Expressions
      "String Manipulation: Formatting, Joining, Splitting, Comparing Strings",
      "Introducing Regular Expressions",

      // State Management
      "State Management-Session, Cookie, Query String: Understanding Basic Session Functionality",
      "Starting a Session and Registering Session Variables",
      "Using Session Variables, Destroying Variables and Sessions",
      "What is a Cookie? Setting, Using, and Deleting Cookies",
      "Implementing Query Strings and Hidden Fields",

      // MySQL Database Integration
      "Introduction to DBMS and MySQL",
      "Web Database Design & Architecture",
      "Creating a MySQL Database and Tables",
      "Column Data Types, Insert/Delete/Update and Select Queries",
      "Aggregate Functions, Having, and Group By Clauses",
      "Joining Tables, Implementing Keys & Constraints",
      "Dropping Tables and Databases",

      // Database Connection
      "MySQL Database Connectivity",

      // Advanced PHP Techniques
      "PDF Generation",
      "Excel or CSV Generation",
      "Implementing Pagination",
      "Exception Handling"
    ],
    targetAudience: "Beginners and intermediate developers who want to build dynamic web applications with PHP and MySQL."
  },
   htmlAndJavaScript: {
    name: "HTML and JavaScript",
    description: "Learn the foundations of web development with HTML for structuring pages and JavaScript for interactivity and dynamic behavior.",
    className: "htmlAndJavaScript",
    icon: faHtml5,
    fee: 15000,
    duration: "3 months",
    prerequisites: [
      "Basic understanding of web technologies",
      "Basic computer programming knowledge"
    ],
    content: [
      // HTML Topics
      "Introduction to HTML",
      "A Brief History of HTML-The World Wide Web",
      "User Agents (Browsers)",
      "The Building Blocks of a Webpage-HTML and Word Processors",
      "HTML Tags and Tag Attributes",
      "Nesting Tags",
      "Fundamental Tags",
      "Creating a Simple HTML Document-The Meta Tag",
      "Adding Comments to HTML",

      // JavaScript Topics
      "Introduction to JavaScript-What is JavaScript?",
      "Evolution of JavaScript",
      "Features of JavaScript",
      "Advantages and Disadvantages of JavaScript",
      "How Does JavaScript Work?",
      "Structure of a JavaScript Program",
      "How to Write JavaScript in Notepad++, Visual Studio Code, and Eclipse IDE?",
      "How to Add JavaScript in HTML?",
      "How to Include External JavaScript in HTML?",
      
      "Data Types and Variables in JavaScript-JavaScript Comments",
      "JavaScript Keywords",
      "JavaScript Data Types",
      "JavaScript Variables",
      "Types of Variables in JavaScript",
      "Key Differences between Var, Let, and Const",

      // JavaScript Operators
      "What are Operators in JavaScript?-Assignment Operators",
      "Comparison Operators",
      "Logical Operators",
      "Conditional Operators",
      "Bitwise Operators",
      "Unary Operators",
      "TypeOf Operator",
      "Operator Precedence",

      "JavaScript Statements-Conditional Statements: If, If-else, Switch",
      "Loop Statements: While Loop, Do-While Loop, For Loop, Nested For Loops",
      "For In and For Of Loops",
      "Break and Continue Statements",

      // Functions in JavaScript
      "What is a Function?-Calling Functions with Arguments",
      "Pass by Value in JavaScript",
      "Returning Values from Functions",
      "Nested Functions",
      "Rest Parameters",
      "Anonymous Functions",
      "Recursion",
      "Arrow Functions",

      // JavaScript Objects
      "What is an Object in JavaScript?-Types of JavaScript Objects",
      "Array Objects: Properties and Methods",
      "String Objects: Properties and Methods",
      "Math Objects: Properties and Methods",
      "Date Objects: Properties and Methods",
      "Global Object: Properties and Methods",
      "Number Objects: Properties and Methods",
      "Creating Custom Objects and Defining Methods",

      "Window and Frame Objects-Top-level Objects",
      "Window Object: Properties, Methods, and Creating a Window",
      "Working with Timeouts",
      "Location Object: Properties and Methods",
      "Document Object: Properties and Methods",
      "Navigator Object: Properties and Methods",
      "History Object: Properties and Methods",
      "Screen Object: Working with Screens",
      "Working with Frames",

      "Event Handling in JavaScript-Understanding Events and How They Work",
      "Creating and Changing Event Handlers",
      "Mouse and Keyboard Events",
      "The onLoad and onUnload Events",
      "Event Object and Event Capturing",
      "Event Bubbling and Preventing Event Bubbling",

      "Exception Handling in JavaScript-Understanding Exceptions and Errors",
      "The try-catch-finally Construction",
      "Throwing Exceptions",
      "Error Object: Properties and Methods",

      "Form Handling in JavaScript-Working with the Form Object",
      "Accessing Form Elements",
      "Input Element Objects: Text, Password, Hidden, Checkbox, Radio, File Inputs",
      "Select and Option Element Objects",
      "Working with Button, Image, and Textarea Elements",

      "Document Object Model (DOM)-Introduction to DOM and W3C",
      "DOM Levels and JavaScript",
      "Element Referencing in DOM",
      "Hierarchy of Nodes in DOM",
      "Node Properties and Methods",
      "Generating New Node Content",
      "Replacing Node Content"
    ],
    targetAudience: "Beginner web developers who want to learn HTML and JavaScript fundamentals to build interactive websites."
  },
  pythonDataAnalysis: {
    name: "Python Data Analysis",
    description: "Learn data analysis techniques using Python. Cover libraries like Pandas, NumPy, Matplotlib, and Seaborn to process, analyze, and visualize data effectively.",
    className: "pythonDataAnalysis",
    icon: faPython,
    fee: 18000,
    duration: "4 months",
    prerequisites: [
      "Basic Python programming skills",
      "Understanding of basic statistics",
      "Interest in data-driven decision making",
    ],
    content: [
      "Python Basics:Python Data Types",
      "Python Loops",
      "Functions",
      "Exception Handling",
      "Complex Datatypes",
      "Modules",
      "Generators and Iterators",
      "IPython",

      "Data Manipulation with Pandas:Introducing Pandas Objects",
      "Data Indexing and Selection",
      "Operating on Data in Pandas",
      "Handling Missing Data",
      "Hierarchical Indexing",
      "Combining Datasets: Concat and Append",
      "Combining Datasets: Merge and Join",
      "Aggregation and Grouping",
      "Pivot Tables",
      "Vectorized String Operations",
      "Working with TimeSeries",
      "High Performance Pandas: eval() and query()",

      "Visualization with Matplotlib:Simple Line Plots",
      "Simple Scatter Plots",
      "Visualizing Errors",
      "Density and Contour Plots",
      "Histograms, Binnings, and Density",
      "Customizing Plot Legends",
      "Customizing Colorbars",
      "Multiple Subplots",
      "Text and Annotation",
      "Customizing Ticks",
      "Customizing Matplotlib: Configurations and Stylesheets",
      "Three-Dimensional Plotting in Matplotlib",
      "Geographic Data with Basemap",
      "Visualization with Seaborn",
    ],
    targetAudience: "Aspiring data analysts, students, and professionals looking to build practical data analysis skills with Python."
  },
   redHatSystemAdministrationI: {
    name: "Red Hat System Administration I",
    description: "Learn essential skills for configuring and managing Red Hat Enterprise Linux systems, covering command-line usage, file management, user management, and system configurations.",
    className: "redHatSystemAdministrationI",
    icon: faCloudflare,
    fee: 25000,
    duration: "4 months",
    prerequisites: [
      "Basic knowledge of Linux or Unix systems",
      "Familiarity with IT fundamentals",
    ],
    content: [
      "Accessing the Command Line: Recognize the BASH shell based on the default prompt",
      "Use Linux efficiently by switching between virtual consoles",
      "Display usage messages and interpret a command's syntax",
      "Managing Files from the Command Line: Recognize and Find Familiarity in a File-system Tree",
      "Learn Terms Like ‘root’ Directory and Subdirectory",
      "Introduction to Different types of Data in Separate System Directories",
      "Getting Help in Red Hat Enterprise Linux: Learn ‘man’ Terminology, Including Topics and Sections",
      "Become Aware of The importance of less-noticed man sections",
      "Creating, Viewing and Editing Text Files: Describe the Technical Terms Standard Output, and Standard Error",
      "Use Redirection Characters to Control Output to Files",
      "Use Pipe to Control Output to Other Programs",
      "Manage Local Linux Users and Groups: Explain the Role of Users and Groups on a Linux System and How They are understood by the Computer",
      "Controlling Access to Files with Linux File-system Permissions: Explain How the Linux File Permissions Model Works",
      "Monitoring and Managing Linux Processes: Learn the Processes Lifecycle, in Order to better Comprehend Process States",
      "Controlling Services and Daemons: List System Daemons and Network Services Started by System services and Socket",
      "Configuring And Securing Open-ssh Service: Log into a Remote System Using ssh to Run Commands From a Shell Prompt",
      "Analyzing and Storing Logs: Describe the Basic ‘syslog’ Architecture in RHEL7",
      "Managing RHEL Networking: Explain Fundamental Concepts of Computer Networking",
      "Archiving and Copying Files between Systems: Create Backups and Transfer Files Over The Network",
      "Installing and Updating Software Packages: Register System with Your Red Hat Account and Entitle Them to Software Updates for Installed Products",
      "Accessing Linux File-systems: Determine which Directories in the File-system Hierarchy are Stored on Which Storage Devices",
      "Using Virtualized Systems: Recognize the Consistent Use of KVM Architecture Throughout the Red Hat Product Line",
    ],
    targetAudience: "System administrators, IT professionals, and those looking to enhance their skills in managing Red Hat Linux systems.",
  },

  redHatSystemAdministrationII: {
    name: "Red Hat System Administration II",
    description: "Enhance your system administration skills with advanced Red Hat Enterprise Linux topics, including automation, process management, and advanced security configuration.",
    fee: 30000,
    className: "redHatSystemAdministrationII",
    icon: faLinux,
    duration: "4 months",
    prerequisites: [
      "Completion of Red Hat System Administration I or equivalent knowledge",
      "Basic understanding of Linux/Unix concepts",
    ],
    content: [
      "Automating Installation with Kickstart: Explain Kickstart Concepts and Architecture",
      "Install and configure Linux using Kickstart",
      "Using Regular Expressions with ‘grep’: Create Regular Expressions that match desired data",
      "Creating and Editing Text Files with vim: Explain the three main modes of ‘vim’",
      "Scheduling Future Linux Tasks: Scheduling tasks using at and cron",
      "Managing Priority of Linux Processes: Explain Linux Processes and nice values",
      "Controlling Access to Files with Access Control Lists (ACL): Describe ACL's and file system mount options",
      "Managing SELinux Security: Explain the Basics of Se-Linux permissions and Context Transitions",
      "Display Current Se-Linux Modes",
      "Interpret the Se-Linux Context of a File",
      "Identify Current Se-Linux Boolean Settings",
      "Connecting to Network-Defined Users and Groups: User authentication using centralized Identity Management Services",
      "Adding Disks, Partitions, and File Systems to a Linux System: Create and Delete disk Partitions on disks with an MBR Partitioning Scheme Using ‘fdisk’",
      "Create and Delete disk Partitions on disks with a GPT Partitioning Scheme Using ‘gdisk’",
      "Format Devices Using ‘mkfs’",
      "Mount File System into the Directory Tree",
      "Managing Logical Volume Management (LVM) Storage: Manage high-performance LVM storage",
      "Accessing Network Attached Storage with Network File System (NFS): Access, Mount, and Unmount NFS Shares",
      "Accessing Network Storage with SMB: How to mount and unmount SMB file-system using the command line",
      "Controlling and Troubleshooting the Red Hat Enterprise Linux Boot Process: Describe and Influence the RHEL Boot Process",
      "Limiting Network Communication with Firewalled: Configure the Basic Firewall Using ‘firewalld’, ‘firewalld-config’, and ‘firewalld-cmd’",
    ],
    targetAudience: "System administrators with experience in Red Hat Linux systems, looking to deepen their expertise in advanced system administration tasks and configurations.",
  },
  sql: {
  name: "SQL for Beginners to Advanced",
  description: "Master SQL from basics to advanced topics including querying, data manipulation, DDL, DML, joins, views, and real-world projects with hands-on exercises.",
  className: "sql",
  icon: faDatabase,
  fee: 15000,
  duration: "3.5 months",
  prerequisites: [
    "Basic understanding of computers",
    "Logical thinking skills",
    "Interest in working with databases",
  ],
  content: [
    "Introduction to SQL: What is SQL?, Why SQL?, Understanding Relational Databases",
    "SQL Command Groups: Overview of DDL, DML, DCL, TCL",
    "Setting up SQL Server: MS SQL Server Installation and Setup",
    "SQL Data Types & Operators: Data Types, Arithmetic Operators, Comparison Operators, Logical Operators",
    "Filtering and Sorting Data: WHERE clause, Sorting with ORDER BY, NULL Comparison",
    "Useful SQL Operations: DISTINCT, TOP N Records, Combining Results using UNION, Using Aliases",
    "Aggregating Data in SQL: Aggregate Functions (SUM, COUNT, AVG, MIN, MAX), GROUP BY, HAVING, OVER Clause",
    "Writing Sub-Queries: Understanding and Writing Sub-queries",
    "Common Functions in SQL: Ranking Functions, Date & Time Functions, Logical Functions, String Functions, Conversion Functions, Mathematical Functions",
    "Analytic Functions in SQL: Introduction and Usage of Analytic Functions",
    "Writing DML Statements: Insert, Update, Delete Operations",
    "Writing DDL Statements: Create, Alter, Drop Operations",
    "Using Constraints in SQL: NOT NULL, UNIQUE, PRIMARY KEY, FOREIGN KEY, CHECK, DEFAULT Constraints",
    "Working with Joins: Cartesian Join, Inner Join, Left & Right Join, Full Outer Join, Self Joins",
    "Working with Views: Create, Update, Drop Views",
    "End-to-End Project: Apply All Concepts in a Real-World Project",
  ],
  targetAudience: "Aspiring data analysts, backend developers, database administrators, and IT professionals looking to master SQL skills.",
},
vmware7: {
  name: "VMware 7.0",
  description: "Learn VMware vSphere 7.0 to install, configure, and manage ESXi hosts and vCenter Server. Master virtualization, storage, networking, resource management, clusters, and lifecycle management.",
  className: "vmware7",
  icon: faServer, // or another suitable FontAwesome icon you prefer
  fee: 45000, // you can update fee if needed
  duration: "2.5 months",
  prerequisites: [
    "Basic knowledge of virtualization concepts",
    "Understanding of networking and storage fundamentals",
  ],
  content: [
    "Introduction to vSphere and Software-Defined Data Center",
    "Overview of vSphere and Virtual Machines",
    "vSphere Virtualization of Resources",
    "vSphere User Interfaces and Overview of ESXi",
    "Creating and Managing Virtual Machines",
    "Virtual Machine Hardware Deep Dive",
    "Introduction to Containers",
    "Centralized Management with vCenter Server",
    "Deploying vCenter Server Appliance",
    "vSphere Licensing and Inventory Management",
    "Roles, Permissions, Backup, and Monitoring",
    "vCenter Server High Availability",
    "Configuring and Managing Virtual Networks",
    "Standard Switches and Policies",
    "Configuring and Managing Virtual Storage",
    "Storage Concepts: Fibre Channel, iSCSI, VMFS, NFS, vSAN",
    "Virtual Machine Management: Templates, Clones, Content Libraries",
    "VM Migration with vMotion and Storage vMotion",
    "Snapshots, Replication, and Backup",
    "Resource Management and Monitoring",
    "vSphere Clusters: DRS, HA, and Fault Tolerance",
    "vSphere Lifecycle Management and Updates",
  ],
  targetAudience: "This course is ideal for system administrators, IT professionals, and anyone aiming to build expertise in managing VMware vSphere environments.",
},
mongoDB: {
  name: "MongoDB",
  description: "Learn MongoDB, the leading NoSQL database. Cover everything from basic setup to advanced querying, cloud services, and connectivity with different programming languages.",
  className: "mongoDB",
  icon: faGlobe, // (use any icon you like, faDatabase is common for databases)
  fee: 18000,
  duration: "2.5 months",
  prerequisites: [
    "Basic understanding of databases",
    "Knowledge of any programming language",
    "Familiarity with CRUD operations",
  ],
  content: [
    "Introduction to MongoDB:No SQL Database",
    "Advantage over RDBMS",
    "MongoDB Data Types",
    "Install MongoDB",
    "MongoDB Data Modeling",
    "MongoDB Opertors:Query & Projection Operator",
    "MongoDB Update Operator",
    "Aggregation Pipeline Stages",
    "MongoDB limit()",
    "MongoDB sort()",
    "Query Modifiers",
    "Database Commands:Aggregation Commands",
    "Geospatial Command",
    "Query and Write Operation Commands",
    "Query Plan Cache Commands",
    "Authentication Commands",
    "User Management Commands",
    "Role Management Commands",
    "Replication Command",
    "Sharding Commands",
    "Session Commands",
    "Database:Create Database",
    "Drop Database",
    "Collection:Create Collection",
    "Drop Collection",
    "CRUD:Documents:Insert Documents",
    "Update Documents",
    "Delete Documents",
    "Query Documents",
    "SQL to MongoDB Mapping",
    "MongoDB Text Search",
    "Partial Updates & Document Limits",
    "Removing Documents",
    "Multi Update",
    "Upsert",
    "Wire Protocol",
    "Bulk() Operations and Methods",
    "Common Commands",
    "db.runCommand()",
    "db.isMaster()",
    "db.serverStatus()",
    "db.currentOp() & db.killOp()",
    "collection.stats() & collection.drop()",
    "MongoDB Shell:MongoDB Shell",

    "Shell Collection Methods",
    "Cursor Method",
    "MongoDB Database Commands",
    "Query Plan Cache Methods",
    "User Management Method",
    "Role Management Method",
    "MongoDB Replication Methods",
    "MongoDB Stitch",
    "MongoDB Atlas",
    "MongoDB Cloud Manager",
    "MongoDB Ops Manager",
    "MongoDB Compass",
    "MongoDB BI Connector",
    "Java MongoDB",
    "PHP MongoDB",
    "Python MongoDB"
  ],
  targetAudience: "This course is ideal for backend developers, database administrators, and software engineers who want to master NoSQL databases and cloud data management."
},
informationSecurityPrograms: {
  name: "Information Security Programs",
  description: "Explore specialized programs focusing on Governance, Risk, and Compliance (GRC), Secured Digital Marketing, and Data Privacy.",
  className: "informationSecurityPrograms",
  icon: faKey,
  fee: 22000,
  duration: "3 months",
  prerequisites: [
    "Basic understanding of cybersecurity",
    "Knowledge of IT systems and digital marketing is helpful",
  ],
  content: [
    "Governance, Risk & Compliance (GRC)",
    " Module 1: Introduction to GRC",
    " Module 2: Governance Fundamentals",
    " Module 3: Risk Management Basics",
    " Module 4: Compliance Frameworks and Regulations",
    " Module 5: GRC Technology and Tools",
    " Module 6: GRC Auditing and Assurance",
    " Module 7: Advanced Topics in GRC",
    " Module 8: GRC Implementation and Integration",
    " Module 9: GRC Case Studies and Practical Applications",
    " Module 10: Future Trends and Emerging Technologies in GRC",
    
    "Secured Digital Advertisement & Marketing",
    " Module 1: Introduction to Cybersecurity in Digital Marketing",
    " Module 2: Social Media Fraud and Crime Prevention",
    " Module 3: Financial Frauds and Crimes Detection & Protection",
    " Module 4: Content Management System (CMS) Security",
    "  Module 5: WordPress Security for Marketers",
    "  Module 6: Pixel and Hashtag Security",
    " Module 7: Plugins and Themes Security",
    " Module 8: Malware and Antivirus in Marketing",
    " Module 9: Internet Security and Controls for Marketing",
    " Module 10: Website Security and Protection",
    " Module 11: Security Controls on Social Networking Sites",
    " Module 12: Email Security and Secure Campaigns",
    
    "Data Privacy and Data Protection",
    " Module 1: Introduction to Data Privacy",
    " Module 2: Fundamentals of Personal Data",
    " Module 3: Data Privacy Laws and Compliance",
    " Module 4: Data Privacy Impact Assessment (DPIA)",
    "  Module 5: Data Breach Management and Incident Response",
    "  Module 6: Privacy by Design and Default",
    "  Module 7: Cross-Border Data Transfers",
    " Module 8: Data Privacy Audits and Assessments",
    " Module 9: Emerging Trends in Data Privacy",
    " Module 10: Advanced Topics in Data Privacy",
  ],
  targetAudience: "This course is ideal for cybersecurity enthusiasts, compliance professionals, marketing teams, and anyone seeking a career in information security and data privacy."
}
,
advancedEthicalHacking: {
  name: "Advanced Ethical Hacking",
  description: "This advanced program delves deeper into ethical hacking techniques, penetration testing, and vulnerability assessments.",
  className: "advancedEthicalHacking",
  icon: faLock,
  fee: 25000,
  duration: "4 months",
  prerequisites: [
    "Basic understanding of cybersecurity and networking principles",
    "Familiarity with operating systems (Linux/Windows)",
    "Prior experience in ethical hacking or penetration testing is highly recommended",
  ],
  content: [
    "Stage 1: Fill Technical Gaps",
    "Module 1: Fundamentals of Ethical Hacking",
    " Information Security Overview",
    " Information Security Threats and Attack Vectors",
    " Hacking Concepts and their Types",
    " Penetration Testing Concepts and their Types",
    " Scope of Ethical Hacking",
    "Module 2: Pentest Lab setup and OS Dos Command",
    " Fundamental of VMware and Virtual Box",
    " VM Network Setting (NAT/Bridge/Host-only)",
    " Virtualization of Windows and Linux",
    " Installation of Kali Linux",
    " Command Kung-fu for Windows and Linux",
    "Tools: VMware and Virtual Box OS: Windows, Linux and Kali Linux",
    "Module 3: Basic Networking",
    " Fundamental IP Address & Subnet Mask",
    " Network Devices",
    " OSI Layer Model vs TCP|IP Model",
    " ARP, ICMP, TCP, UDP protocol",
    " TCP Flags",
    " TCP 3-way handshake",
    "  Well known Services Port",

    "Stage 2: Reconnaissance",
    "Module 4: Footprinting",
    " OSINT Framework",
    " Email Footprinting",
    " DNS Footprinting",
    "  Web FootPrinting",
    " Google Hacking Database",
    "Tools: Shodan, Whois, DNS Dumpster, Exploit DB, Hunter, iplogger, OSINT, Httrack and similar alternative tools",
    "Module 5: Network Scanning",
    " Host Discovery",
    " OS Fingerprinting",
    "  Subnet Scanning",
    "  Default Scan",
    "  Stealth Scan",
    "  TCP Scan",
    "  UDP Scan",
    "  port Scan",
    "  ALL port Scan",
    "  Version Scan",
    "  Script Scan",
    " Decoy Scan",
    " Fast Scan",
    " Time Scan",
    " Aggressive Scan",
    "Tools: Nmap, netdiscover, Zenmap, advanced IP scanner and similar alternative tools",
    "Module 6: Enumeration",
    "  NetBios Enumeration",
    "  FTP Enumeration",
    " SMB Enumeration",
    " Telnet Enumeration",
    " SMTP Enumeration",
    "Tools: Nmap, Rpcclient, SMBmap, SMBclient, NBTScan and similar alternative tools",

    "Stage 3: Exploitation",
    "Module 7: System Hacking",
    " Scanning Vulnerability",
    "  Exploiting Vulnerability",
    " Password Brute Force",
    " Creating Malicious File Type (eg: Exe, Elf, apk)",
    " Metasploit Framework – Auxiliaryes, Exploits, Payloads Post Modules & meterpreter",
    "  Msfvenom Framework",
    "Tools: Metasploit, Msfvenom, Netcat",
    "Module 8: Post Exploitation",
    " Post Enumeration",
    " Gathering System information",
    " Gathering User Information",
    " Download and Upload operations",
    " Process Migrate",
    " Web Camera Hacking",
    " Collect Stored Credentials (System, Browser, Wifi)",
    " Privilege Escalation to gain Administrator Access",
    " Hashdump",
    " Clear Event logs",
    "  Persistence to maintain permanent access",
    "Tools: Metasploit Post Modules",
    "Module 9: Malware and Threats",
    " Malware Concept",
    " Techniques used for Spreading Malware",
    " Trojan Concept Vs Virus and Worm",
    " Payload Binders and Crypter",
    " Countermeasures",
    " Malicious Process Analysis",
    "Tools: Trojans RAT, Virus Total, TCP View, Process Explorer, Ad blocker",

    "Stage 4: Cyber Threats",
    "Module 10: Web Hacking",
    " Introduction to Web Server and Web Applications",
    " Well Know web servers and CMS",
    "  Introduction to OWASP",
    " Website Scanning",
    " Introduction to burpsuite",
    " SQL injection",
    " Cross-Site Scripting",
    " Remote command Execution",
    "  Brute Force",
    "Tools: Wappalyzer, Burpsuite, Sqlmap, Nikto",
    "Module 11: Social Engineering",
    " Social Engineering Concepts",
    " Social Engineering Techniques",
    "  Email Spoofing",
    " Geolocation",
    " Credential Harvesting",
    " Haveibeenpwned",
    "  Detect a phishing attack",
    "Tools: Social Engineering Toolkit, Phishtank, Mxtool box, Iplogger",
    "Module 12: Mobile Hacking",
    " Kali Linux NetHunter",
    " Generating Malicious APK",
    " Fake SMS",
    "  Fake caller",
    " Key loggers",
    " Introduction to Rooted Devices",
    " Trace Phone Location",
    "  Anonymous Chat Application",
    " Network Mapper",
    " Wi-Fi Kill",
    "Tools: Nirsoft, Fing, Online Application, Net hunter",

    "Stage 5: Network Attack",
    "Module 13: Sniffing and Spoofing",
    " Introduction Sniffing and Its Types",
    "  Spoofing",
    "  Man-in-the-Middle Attack",
    "  ARP Poisoning",
    " DNS Poisoning",
    " Password Sniffing",
    " HTTP Password Capture",
    "  Telnet Password Capture",
    " FTP Password Capture",
    "Tools: Ettercap, Wireshark and similar alternatives tools",
    "Module 14: Denial of Service",
    " Introduction of DOS Attack & Its Types",
    " Distributed Denial of Service DDOS",
    "  Botnet",
    " DOS Attack",
    " SYN Flood",
    " ICMP Flood",
    "  UDP Flood",
    " TCP Flood",
    "  Blue Screen Death Attack",
    "Tools: Golden-eye, Hping3, Metasploit Framework",
    "Module 15: Wireless Hacking",
    " Introduction to Wireless standard IEEE",
    " Introduction to WIFI Security & Protocols",
    " Detect Hidden SSID",
    " Monitor mode Vs promiscuous mode",
    "  Capture WPA/WPA2 Handshake",
    " WPA/WPA2 Password cracking",
    "  Evil Twin",
    "  Dump Wifi Credentials",
    "Tools: Alpha wifi Adapter, Airgeddon",

    "Stage 6: Network Security Essentials",
    "Module 16: IDS, Firewalls, and Honeypots",
    " Introduction to IDS, IPS Firewall, DMZ & Honeypots",
    " Honey Bot, Kfsensor",
    "  Windows Advanced Firewall Rules",
    " Evading Firewall",
    "  Event Log Management",
    " Fundamentals of DLP",
    "Tools: Windows ACL, Linux Iptables, Event Viewer, Kfsensor, Snort",
    "Module 17: Cryptography & Steganography",
    " Introduction to Information Security & CIA Model",
    " Basic Concept of Encoding",
    " Base64",
    "  Binary",
    "  Hexa Decimal",
    "  Basic Concept of Steganography",
    "  Image, audio and file-based Steganography",
    "  Introduction to Cryptography",
    "  Cesar cypher",
    "  Rot 13",
    "  Modern Cryptography",
    " AES Symmetric Encryption",
    "  PGP Asymmetric Encryption",
    " Basic Concept of Hashing",
    " Hash Calculator",
    " Signature Compression",
    "Tools: Steghide, PowerShell, Online Tools",

    "Comprehensive Tools List:",
    "1. VMware and Virtual Box OS: Windows, Linux and Kali Linux",
    "2. Shodan, Whois, DNS Dumpster, Exploit DB, Hunter, iplogger, OSINT, Httrack",
    "3. Nmap, netdiscover, Zenmap, advanced IP scanner",
    "4. Nmap, Rpcclient, SMBmap, SMBclient, NBTScan",
    "5. Metasploit, Msfvenom, Netcat",
    "6. Metasploit Post Modules",
    "7. Trojans RAT, Virus Total, TCP View, Process Explorer, Ad blocker",
    "8. Wappalyzer, Burpsuite, Sqlmap, Nikto",
    "9. Social Engineering Toolkit, Phishtank, Mxtool box, Iplogger",
    "10. Nirsoft, Fing, Online Application, Net hunter",
    "11. Ettercap, Wireshark",
    "12. Golden-eye, Hping3, Metasploit Framework",
    "13. Alpha wifi Adapter, Airgeddon",
    "14. Windows ACL, Linux Iptables, Event Viewer, Kfsensor, Snort",
    "15. Steghide, PowerShell, Online Tools"
  ],
  targetAudience: "This course is ideal for experienced cybersecurity professionals, penetration testers, network security engineers, and those aspiring to become expert ethical hackers or security consultants. It is designed for individuals who want to deepen their knowledge in real-world penetration testing and vulnerability management."
}

,
devOpsWithAWS: {
  name: "DevOps with AWS",
  description: "Comprehensive DevOps training covering CI/CD pipelines, infrastructure as code, containerization, and AWS cloud services.",
  className: "devOpsWithAWS",
  icon: faProjectDiagram,
  fee: 30000,
  duration: "5 months",
  prerequisites: [
    "Basic understanding of Linux commands",
    "Familiarity with software development lifecycle",
    "Fundamental knowledge of cloud computing concepts"
  ],
  content: [
    "Core DevOps Concepts",
    " Why DevOps: Organizational, Stakeholder, Developer, Tester, and Operations perspectives",
    " Agile and SDLC: Introduction, Phases, Roles",
    "  DevOps vs Agile: Team roles and responsibilities",
    "  DevOps Automation Overview: CI/CD, Configuration Management, Monitoring",
    
    "Cloud Computing Fundamentals",
    "  Cloud Models: SAAS, PAAS, IAAS",
    "  Public, Private and Hybrid clouds",
    "  Cloud Benefits and Challenges",
    "  DevOps in Cloud Environments",
    
    "Linux Essentials for DevOps",
    "  Core Linux Commands",
    "  Filesystem Hierarchy",
    "  SSH Remote Access",
    "  Permission Management",
    "  Package and Service Management",
    
    "AWS Core Services",
    " EC2: Instances, AMIs, Pricing Models",
    " IAM: User Management, MFA, Roles, Policies",
    " S3: Bucket Management, Versioning, Lifecycle Rules",
    " RDS: Database Setup, Backups, Replication",
    " VPC: Networking, Security Groups, NAT",
    " ELB: Load Balancer Types, Health Checks",
    " Auto Scaling: Launch Configurations, Scaling Policies",
    
    "Build Tools",
    "  Maven: Build Lifecycle, Dependencies, Repositories",
    "  Project Templates and Automation",
    
    "Version Control Systems",
    "  Git: Installation, Configuration, Branching",
    "  GitHub/GitLab: Repository Management",
    " CI/CD Integration",
    
    "Continuous Integration with Jenkins",
    "  Installation and Configuration",
    "  Pipeline Creation",
    "  Plugin Management",
    "  Build Automation",
    "  Test Integration",
    "  BlueOcean UI",
    "  Security Implementation",
    
    "Configuration Management with Ansible",
    " Architecture and Components",
    " Playbooks and Modules",
    "  Inventory Management",
    "  Roles and Templates",
    "  Vault for Secrets Management",
    " Ansible Tower Implementation",
    
    "Containerization with Docker",
    "  Docker Architecture",
    "  Image Creation and Management",
    "  Container Orchestration Basics",
    "  Docker Compose",
    "  Registry Management",
    
    "Kubernetes Orchestration",
    " Cluster Architecture",
    "  Minikube Setup",
    "  Pods, Deployments, Services",
    "  Helm Charts",
    "  Autoscaling",
    "  Istio Service Mesh",
    "  Monitoring and Logging",
    
    "Infrastructure as Code with Terraform",
    "  HCL Syntax",
    "  Resource Provisioning",
    "  State Management",
    "  Modules",
    "  AWS Provider",
    "  Best Practices",
    
    "Additional Tools",
    " SonarQube: Code Quality Analysis",
    "  Apache Tomcat: Web Application Deployment",
    
    "DevOps Implementation Strategies",
    "  Microservices Architecture",
    "  Serverless Implementations",
    "  Monitoring and Alerting",
    "  Security Best Practices",
    "  Cost Optimization Techniques"
  ],
  toolsCovered: [
    "Jenkins", "Ansible", "Docker", "Kubernetes", "Terraform",
    "Maven", "Git", "GitHub", "GitLab", "Apache Tomcat",
    "SonarQube", "AWS CLI", "Helm", "Istio", "Prometheus",
    "Grafana", "ELK Stack", "Minikube", "Kops", "Kubeadm"
  ],
  targetAudience: "This course is designed for IT professionals, system administrators, developers, and engineers looking to transition into DevOps roles. It's ideal for those wanting to master cloud-native DevOps practices with hands-on AWS experience and modern toolchains."
},
devOpsTraining: {
  name: "DevOps Training",
  description: "Complete DevOps training covering infrastructure setup, version control, containerization, CI/CD pipelines, and more.",
  className: "devOpsTraining",
  icon: faTools,
  fee: 25000,
  duration: "6 months",
  prerequisites: [
    "Basic understanding of software development lifecycle",
    "Familiarity with Linux and command-line tools",
    "Knowledge of cloud computing"
  ],
  content: [
    "Module 01 - Infrastructure Setup",
    "1.1 EC2 Walkthrough",
    "1.2 Installation of DevOps Tools in the Cloud",
    "Git",
    "Docker",
    "Selenium",
    "Jenkins",
    "Puppet",
    "Ansible",
    "Kubernetes",
    "ELK",
    
    "Module 02 - Introduction to DevOps",
    "2.1 What is Software Development?",
    "2.2 Software Development Life Cycle",
    "2.3 Traditional Models for SDLC",
    "2.4 Why DevOps?",
    "2.5 What is DevOps?",
    "2.6 DevOps Lifecycle",
    "2.7 DevOps Tools",
    
    "Module 03 - Version Control with Git",
    "3.1 What is Version Control?",
    "3.2 Types of Version Control System",
    "3.3 Introduction to SVN",
    "3.4 Introduction to Git",
    "3.5 Git Lifecycle",
    "3.6 Common Git Commands",
    "3.7 Working with Branches in Git",
    "3.8 Merging Branches",
    "3.9 Resolving Merge Conflicts",
    "3.10 Git Workflow",
    
    "Module 04 - Containerization Using Docker - 1",
    "4.1 Introduction to Docker",
    "4.2 Understanding Docker Lifecycle",
    "4.3 Components of Docker Ecosystem",
    "4.4 Common Docker Operations",
    "4.5 Creating a DockerHub Account",
    "4.6 Committing changes in a Container",
    "4.7 Pushing a Container Image to DockerHub",
    "4.8 Creating Custom Docker Images using Dockerfile",
    
    "Module 05 - Configuration Management using Puppet",
    "5.1 Need for Configuration Management",
    "5.2 Configuration Management Tools",
    "5.3 What is Puppet",
    "5.4 Puppet Architecture",
    "5.5 Setting up Master-Slave using Puppet",
    "5.6 Puppet Manifests",
    "5.7 Puppet Modules",
    "5.8 Applying configuration using Puppet",
    "5.9 Puppet File Server",
    
    "Module 06 - Ansible",
    "6.1 What is Ansible?",
    "6.2 Ansible vs Puppet",
    "6.3 Ansible Architecture",
    "6.4 Setting up Master-Slave using Ansible",
    "6.5 Ansible Playbook",
    "6.6 Ansible Roles",
    "6.7 Applying configuration using Ansible",
    
    "Module 07 - Continuous Testing using Selenium",
    "7.1 What is Continuous Testing?",
    "7.2 What is Maven?",
    "7.3 Introduction to Selenium",
    "7.4 Running Test Cases on Chromium Web Driver",
    "7.5 What is Headless Mode?",
    
    "Module 08 - Continuous Integration with Jenkins",
    "8.1 Introduction to Continuous Integration",
    "8.2 Jenkins Master-Slave Architecture",
    "8.3 Understanding CI/CD Pipelines",
    "8.4 Creating an end-to-end automated CI/CD Pipeline",
    
    "Module 09 - Introduction to Kubernetes Part 1",
    "9.1 Introduction to Kubernetes",
    "9.2 Docker Swarm vs Kubernetes",
    "9.3 Kubernetes Architecture",
    "9.4 Deploying Kubernetes using Kubeadm",
    "9.5 Alternate ways of deploying Kubernetes",
    "9.6 YAML Files",
    "9.7 Creating a Deployment in Kubernetes using YAML",
    "9.8 Services in Kubernetes",
    "9.9 Ingress in Kubernetes",
    "9.10 Case Study – Kubernetes Architecture",
    
    "Module 10 - Introduction to Kubernetes Part 2",
    "10.1 What are volumes?",
    "10.2 Types of volumes",
    "10.3 Persistent volumes",
    "10.4 Introduction to secrets",
    "10.5 Taints and tolerations",
    "10.6 Introduction to Federation",
    "10.7 Kubernetes Monitoring",
    "10.8 Setting up Prometheus",
    "10.9 Setting up Grafana",
    
    "Module 11 - Continuous Monitoring using ELK",
    "11.1 Agenda",
    "11.2 What is ELK?",
    "11.3 Components of ELK",
    "11.4 ELK Flow",
    "11.5 Features of ELK",
    "11.6 ELK installation",
    
    "Module 12 - Terraform Modules & Workspaces",
    "12.1 What is Infrastructure as Code",
    "12.2 IaC vs Configuration Management",
    "12.3 Introduction to Terraform",
    "12.4 Installing Terraform on AWS",
    "12.5 Basic Operations in Terraform",
    "init",
    "plan",
    "apply",
    "destroy",
    "12.6 Terraform Code Basics",
    "12.7 Deploying an end-to-end architecture on AWS using Terraform",
    
    "Hands-on Project and Assignment"
  ],
  toolsCovered: [
    "Git", "Docker", "Selenium", "Jenkins", "Puppet", "Ansible", "Kubernetes", "ELK", "Terraform"
  ],
  targetAudience: "This course is designed for software developers, IT professionals, and system administrators who want to expand their knowledge and skills in DevOps practices and tools, with hands-on experience in cloud environments like AWS."
}
,
dataScienceAndMLWithPython: {
  name: "Data Science and Machine Learning with Python",
  description: "Comprehensive training covering Python for data science, statistical modeling, machine learning algorithms, and data visualization techniques using industry-standard tools and libraries.",
  className: "dataScienceAndMLWithPython",
  icon: faChartLine, // Font Awesome chart line icon
  fee: 30000,
  duration: "6 months",
  prerequisites: [
    "Basic understanding of programming concepts",
    "Familiarity with mathematics and statistics",
    "No prior Python experience required but helpful"
  ],
  content: [
    "Stage 1: Python Fundamentals",
    "Module 1: Python Environment Setup",
    "Anaconda distribution",
    "Jupyter Notebook basics",
    "Virtual environments",
    "Module 2: Python Programming Basics",
    "Data types and variables",
    "Iterables and containers (Lists, Tuples, Dictionaries)",
    "Conditionals and loops",
    "Functions and lambda expressions",

    "Stage 2: Data Handling and Visualization",
    "Module 3: Data Importing and EDA",
    "Reading CSV, Excel, JSON files",
    "Exploratory Data Analysis techniques",
    "Descriptive statistics",
    "Module 4: Data Visualization",
    "Scatterplots and line graphs",
    "Bar plots and stacked bar charts",
    "Pie charts and box plots",
    "Histograms and density plots",
    "Matplotlib and Seaborn libraries",
    "Interactive visualization with Plot.ly",
    "Module 5: Data Cleaning and Preprocessing",
    "Handling missing values and outliers",
    "Dealing with inconsistent data",
    "Data reshaping (filtering, merging, dropping)",
    "Feature selection and scaling",

    "Stage 3: Statistical Modeling",
    "Module 6: Statistical Foundations",
    "Probability distributions",
    "Hypothesis testing",
    "Correlation and covariance",
    "Module 7: Regression Analysis",
    "Simple Linear Regression",
    "Multiple Linear Regression",
    "Polynomial Regression",
    "Model evaluation metrics",

    "Stage 4: Machine Learning",
    "Module 8: Supervised Learning",
    "Classification algorithms",
    "Decision Trees and Random Forests",
    "SVM and Naive Bayes",
    "Module 9: Unsupervised Learning",
    "Clustering techniques (K-Means, Hierarchical)",
    "Dimensionality reduction (PCA)",
    "Module 10: Model Evaluation",
    "Cross-validation techniques",
    "Hyperparameter tuning",
    "Confusion matrices and ROC curves",

    "Stage 5: Advanced Topics",
    "Module 11: Time Series Analysis",
    "ARIMA models",
    "Forecasting techniques",
    "Module 12: Natural Language Processing",
    "Text preprocessing",
    "Sentiment analysis",
    "Module 13: Deployment",
    "Model serialization",
    "Creating prediction APIs",
    "Integration with web applications"
  ],
  toolsCovered: [
    "Python", "Jupyter Notebook", "Anaconda", 
    "NumPy", "Pandas", "SciPy", 
    "Matplotlib", "Seaborn", "Plotly", 
    "Scikit-learn", "Statsmodels", "NLTK"
  ],
  targetAudience: "This course is designed for aspiring data scientists, business analysts, researchers, and anyone looking to build expertise in data science and machine learning using Python. Suitable for both beginners and professionals looking to upskill."
},
cybersecurityAnalystFundamentalsToAdvanced: {
  name: "Cybersecurity Analyst - Fundamentals to Advance",
  description: "8-week program covering cybersecurity basics, network security, threat analysis, and defense strategies—prepares students for real-world challenges and certifications.",
  className: "cybersecurityAnalystFundamentalsToAdvanced",
  icon: faShieldAlt, // Font Awesome shield icon
  fee: 35000,
  duration: "8 weeks",
  prerequisites: [
    "Basic computer literacy",
    "Understanding of internet concepts",
    "No prior cybersecurity experience required"
  ],
  content: [
    "Week 1: Introduction to Cybersecurity",
    " Day 1: Course Overview and Cybersecurity Importance",
    " Day 2: Computing Basics and Operating Systems",
    " Day 3: Networking Fundamentals and OSI Model",
    " Day 4: Cyber Threats and Attack Vectors",
    " Day 5: Security Policies and Compliance Regulations",
    
    "Week 2: Information Security Fundamentals",
    " Day 1: CIA Triad and Risk Management",
    " Day 2: Cryptography Basics (Symmetric/Asymmetric)",
    " Day 3: Password Security and MFA Implementation",
    " Day 4: Social Engineering and Security Awareness",
    " Day 5: Security Governance (ISO 27001, NIST)",
    
    "Week 3: Network Security",
    " Day 1: Firewalls and Intrusion Detection Systems",
    " Day 2: Network Defense Implementation",
    " Day 3: Wireless Security Best Practices",
    " Day 4: VPN Configuration and Management",
    " Day 5: Linux Basics for Security",
    
    "Week 4: Operating System Security",
    " Day 1: OS Security Fundamentals",
    " Day 2: Windows Security Features",
    " Day 3: Linux Hardening Techniques",
    " Day 4: Malware Analysis and Antivirus Tools",
    " Day 5: Vulnerability Assessment Scanning",
    
    "Week 5: Web and Application Security",
    " Day 1: OWASP Top Ten Vulnerabilities",
    " Day 2: Secure Coding Principles",
    " Day 3: Web Application Firewalls (WAFs)",
    " Day 4: Web Penetration Testing Tools",
    " Day 5: Secure SDLC Implementation",
    
    "Week 6: Security Operations",
    "  Day 1: Incident Response Procedures",
    "  Day 2: IDS Configuration and Management",
    "  Day 3: SIEM Implementation and Log Analysis",
    "  Day 4: Security Policy Development",
    "  Day 5: Legal and Ethical Considerations",
    
    "Week 7: Advanced Topics",
    "  Day 1: PKI and Cryptographic Protocols",
    "  Day 2: Cloud Security (AWS/Azure/GCP)",
    "  Day 3: IoT Security Challenges",
    "  Day 4: Red Team/Blue Team Exercises",
    "  Day 5: Cybersecurity Career Paths",
    
    "Week 8: Practical Application",
    "  Day 1-4: Industry Security Project",
    "  Day 5: Certification Exam Preparation"
  ],
  toolsCovered: [
    "Wireshark", "Nmap", "Metasploit", "Nessus", 
    "Snort", "Splunk", "Kali Linux", "Burp Suite", 
    "OpenVAS", "OSSEC", "SIEM solutions", "Firewall technologies"
  ],
  targetAudience: "This course is ideal for IT professionals transitioning to security roles, recent graduates seeking cybersecurity careers, and anyone interested in becoming a cybersecurity analyst or security operations specialist."
},
dataVisualizationWithPowerBI: {
    name: "Data Visualization With PowerBI",
    description: "Learn to create stunning data visualizations and dashboards with PowerBI, covering everything from data modeling to creating DAX functions and integrating data from various sources.",
    duration: "6 months",
    className:"dataVisualizationWithPowerBI",
    icon:faChartPie,
    fee: "40000",
    prerequisites: [
      "Basic understanding of data analysis",
      "Familiarity with Excel and SQL"
    ],
    content: [
      "Business Intelligence",
      "Introduction to Power BI",
      "What is Power BI?",
      "Power BI vs Tableau vs QlikView",
      "Key Benefits of Power BI",
      "Power BI Features",
      "Power BI Components",
      "Power BI Service",
      "The Flow of Power BI",
      "Components of Power BI",
      "The Architecture of Power BI",
      "Building Blocks of Power BI",
      "How to Create Charts and Graphs?",
      "DAX Functions",
      "DAX Syntax",
      "Data Types in DAX",
      "Ranking and Rank Over Groups",
      "Filter and Evaluation Context",
      "Calculation Types",
      "DAX Queries",
      "Data Modeling",
      "Data Models in Power BI",
      "Using Excel and SQL Data in Power BI",
      "Live Connections to Data with Power BI",
      "Import Power View and Power Pivot to Power BI",
      "Data Caching and Refresh",
      "Introducing Power BI Mobile",
      "Power BI Dashboard",
      "Creating Visuals Using Python in Power BI"
    ],
    toolsCovered: [
      "Power BI Desktop",
      "Power BI Service",
      "DAX Functions",
      "Power BI Mobile"
    ],
    targetAudience: "This course is for anyone looking to master data visualization and business intelligence using Power BI. Ideal for data analysts, business analysts, and professionals looking to build strong Power BI skills."
  }
,awsDataScience: {
  name: "AWS Data Science Course",
  description: "Learn how to use AWS services for data science, analytics, and machine learning.",
  duration: "4 months",
  className:"awsDataScience",
  icon:faCloud,
  fee: "30000",
  prerequisites: [
    "Basic understanding of machine learning concepts",
    "Familiarity with AWS services"
  ],
  content: [
    "AWS Athena (Query service for analyzing the data in Amazon S3 or Glacier using SQL)",
    "Simple Storage Service (S3)",
    "AWS Glacier (Online file storage service for long-term data storage)",
    "Relational Database Service (RDS)",
    "Amazon Redshift (Data storage for complex queries)",
    "Amazon QuickSight (Petabyte Scale Data Warehouse)",
    "AWS Glue (ETL and data catalog management)",
    "Amazon SageMaker (Machine Learning and Studio IDE)",
    "Amazon Kinesis Video Streams (Processing and analyzing video data)",
    "Amazon OpenSearch",
    "Amazon DynamoDB (NoSQL databases)",
    "AWS EC2 (Web Application Deployment)",
    "AWS EMR",
    "Amazon EBS (Elastic Block Storage)"
  ],
  targetAudience: "Data scientists, analysts, and anyone interested in learning AWS for data science.",
  toolsCovered: ["AWS Athena", "AWS Glue", "Amazon SageMaker", "Amazon Redshift", "AWS EC2"],
},
databaseProgrammingWithPLSQL: {
  name: "Database Programming with PL/SQL",
  description: "Covers PL/SQL fundamentals, programming structures, exceptions, procedures, functions, packages, triggers, and performance tuning.",
  className: "databaseProgrammingWithPLSQL",
  icon: faCodeBranch, // Font Awesome database icon
  fee: 30000,
  duration: "12 weeks",
  prerequisites: [
    "Basic knowledge of SQL",
    "Understanding of relational databases"
  ],
  content: [
    "Module 1: Fundamentals",
    "Introduction to PL/SQL",
    "Benefits of PL/SQL",
    "Creating PL/SQL Blocks",
    "Defining Variables and Datatypes",
    "Using Variables in PL/SQL",
    "Recognizing PL/SQL Lexical Units",
    "Recognizing Data Types",
    "Using Scalar Data Types",
    "Writing PL/SQL Executable Statements",
    "Nested Blocks and Variable Scope",
    "Good Programming Practices",
    "Using SQL in PL/SQL",
    "Review of SQL DML",
    "Retrieving Data in PL/SQL",
    "Manipulating Data in PL/SQL",
    "Using Transaction Control Statements",

    "Module 2: Program Structures to Control Execution Flow",
    "Conditional Control: IF Statements",
    "Conditional Control: CASE Statements",
    "Iterative Control: Basic Loops",
    "Iterative Control: WHILE and FOR Loops",
    "Iterative Control: Nested Loops",

    "Module 3: Using Composite Datatypes",
    "User-Defined Records",
    "Indexing Tables of Records",

    "Module 4: Using Cursors and Parameters",
    "Introduction to Explicit Cursors",
    "Using Explicit Cursor Attributes",
    "Cursor FOR Loops",
    "Cursors with Parameters",
    "Using Cursors for UPDATE",
    "Using Multiple Cursors",

    "Module 5: Exception Handling",
    "Handling Exceptions",
    "Trapping Oracle Server Exceptions",
    "Trapping User-Defined Exceptions",
    "Recognizing the Scope of Exceptions",

    "Module 6: Using and Managing Procedures",
    "Creating Procedures",
    "Using Parameters in Procedures",
    "Passing Parameters",

    "Module 7: Using and Managing Functions",
    "Creating Functions",
    "Using Functions in SQL Statements",
    "Review of the Data Dictionary",
    "Managing Procedures and Functions",
    "Review of Object Privileges",
    "Using Invoker's Rights and Autonomous Transactions",

    "Module 8: Using and Managing Packages",
    "Creating Packages",
    "Managing Package Concepts",
    "Advanced Package Concepts",

    "Module 9: Getting the Best out of Packages",
    "Persistent State of Package Variables",
    "Using Oracle-Supplied Packages",

    "Module 10: Improving PL/SQL Performance",
    "Using Dynamic SQL",
    "Improving PL/SQL Performance",

    "Module 11: Using and Managing Triggers",
    "Introduction to Triggers",
    "Creating DML Triggers, Part I",
    "Creating DML Triggers, Part II",
    "Creating DDL and Database Event Triggers",
    "Managing Triggers",

    "Module 12: Recognizing and Managing Dependencies",
    "Introduction to Dependencies",
    "Understanding Remote Dependencies",

    "Module 13: Using the PL/SQL Compiler",
    "Using PL/SQL Initialization Parameters",
    "Displaying Compiler Warning Messages",
    "Using Conditional Compilation",
    "Hiding Your Source Code"
  ],
  toolsCovered: [
    "PL/SQL", "SQL*Plus", "Oracle Database", 
    "SQL Developer", "Oracle-supplied packages", 
    "Dynamic SQL", "PL/SQL Compiler"
  ],
  targetAudience: "This course is designed for database administrators, developers, and IT professionals who want to enhance their skills in database programming using PL/SQL. Prior knowledge of SQL is required."
},
apacheCassandra: {
  name: "Apache Cassandra",
  description: "Comprehensive course covering Apache Cassandra fundamentals, architecture, data modeling, and hands-on experience with CQL and Java integration.",
  className: "apacheCassandra",
  icon: faBolt, // Font Awesome server icon
  fee: 40000,
  duration: "8 weeks",
  prerequisites: [
    "Basic understanding of databases",
    "Familiarity with SQL concepts"
  ],
  content: [
    "Module 1: NoSQL Overview",
    "Justifying non-relational data stores",
    "Listing the categories of NoSQL Data Stores",

    "Module 2: Exploring Cassandra",
    "Defining column family data stores",
    "Surveying Cassandra",
    "Dissecting the basic Cassandra architecture",

    "Module 3: Querying Cassandra",
    "Defining Cassandra Query Language, CQL",
    "Enumerating CQL data types",
    "Manipulating data from the cqlsh interface",

    "Module 4: Leveraging Cassandra Structures and Types",
    "Drawing comparisons with the relational model",
    "Organizing data with keyspaces, tables and columns",
    "Creating collections and counters",

    "Module 5: Modeling Data Based on Queries",
    "Designing tables around access patterns",
    "Clustering with compound primary keys",
    "Improving data distribution with composite partition keys",

    "Module 6: Configuring Data Consistency",
    "Detailing tunable consistency",
    "Identifying consistency levels",
    "Selecting appropriate read and write consistency levels",
    "Distinguishing consistency repair features",

    "Module 7: Balancing Consistency and Performance",
    "Relating replication factor and consistency",
    "Trading consistency for availability",
    "Achieving linearizable consistency with Compare-And-Set",

    "Module 8: Working with Cassandra Collection Types",
    "Grouping elements in sets",
    "Ordering elements in lists",
    "Expressing relationships with maps",
    "Nesting collections",

    "Module 9: Storing Data for Easy Retrieval",
    "Mapping data to tuples and user defined types",
    "Investigating the frozen keyword",
    "Applying the Valueless Columns Pattern",
    "Strategic implementation of clustering columns",

    "Module 10: Controlling Data Life Span",
    "Expiring temporal data with time-to-live",
    "Reviewing how tombstones achieve distributed deletes",
    "Executing DELETEs and UPDATEs in the future",

    "Module 11: Constructing Materialized Views and Time Series",
    "Modeling time series data",
    "Enhancing queries with materialized views",
    "Materialized views maintained in the application",
    "Driving analytics from materialized views",

    "Module 12: Managing Triggers",
    "Creating triggers by implementing ITrigger",
    "Attaching triggers to tables",
    "Supporting materialized views with triggers",

    "Module 13: Accessing Cassandra Programmatically",
    "Querying Cassandra data with the Datastax Java Driver",
    "Connecting to a Cassandra cluster",
    "Running CQL through the Java Driver",
    "Batching prepared statements",
    "Paginating large queries",

    "Module 14: Persisting Java Objects with Kundera",
    "Defining the Java Persistence Architecture, JPA",
    "Configuring Kundera to work with Cassandra",
    "Generating schemas automatically",
    "Managing JPA transactions in Kundera"
  ],
  toolsCovered: [
    "Apache Cassandra",
    "Cassandra Query Language (CQL)",
    "Datastax Java Driver",
    "Kundera",
    "Nodetool",
    "JMX monitoring tools"
  ],
  targetAudience: "This course is ideal for database administrators, backend developers, and data engineers seeking to specialize in distributed NoSQL databases and scalable data architectures."
},
ifsTechnicalDevelopment: {
  name: "IFS Technical Development",
  description: "Comprehensive training program covering Integration Development, Custom Objects, Data Migration and Source Control in IFS Applications.",
  className: "ifsTechnicalDevelopment",
  icon: faCode,
  fee: 45000,
  duration: "10 weeks",
  prerequisites: [
    "Basic knowledge of ERP systems",
    "Familiarity with databases and APIs"
  ],
  content: [
    "Module 1: Integration Development - Setting Up and Configuring Integrations",
    "Create transformers capable of handling non-IFS messages through REST API",
    "Demonstrate configuration options for routing Address of messages",
    "Demonstrate configuration options for routing Rule of messages",
    "Demonstrate the tools and techniques of testing services",

    "Module 2: Custom Objects",
    "Configure events in IFS Applications",
    "Demonstrate the creation of custom objects",
    "Demonstrate the modification of custom objects",
    "Examine the differences between custom menus, custom fields, custom LUs and information cards",
    "Introduce events in IFS Applications",

    "Module 3: IFS Data Migration",
    "Create a table using a flat data file",
    "Export IFS data into a flat data file",
    "Import and export data migration jobs",
    "Import data into IFS tables from a source data table",
    "Import new data to IFS tables from a flat data file",
    "Introduce data migration and the technical terms used",
    "Introduce data replication using data migration",

    "Module 4: IFS Lobby & Reports",
    "IFS Lobby concept",
    "Lobby data source designer",
    "Lobby element designer",
    "Lobby page designer",
    "Managing lobbies",

    "Module 5: Reports",
    "Operational reports using IFS Developer Studio and Report Designer tool",
    "Ad-hoc Reports",

    "Module 6: Aurena Form Development",
    "Create Entity file and Client file",

    "Module 7: Background Jobs",
    "Create background jobs to schedule business processes",

    "Module 8: Permission Set",
    "Create User",
    "Grant/Revoke Permission Sets to user",

    "Module 9: Source File Commit to GitHub/Harvest",
    "Source code commit"
  ],
  toolsCovered: [
    "IFS Applications",
    "IFS Developer Studio",
    "Aurena Framework",
    "REST APIs",
    "GitHub / Harvest",
    "Report Designer Tool"
  ],
  targetAudience: "This course is ideal for ERP developers, technical consultants, and system administrators aiming to develop, customize, and manage IFS Applications effectively."
},
financialsSupplyChainManagement: {
  name: "Financials Supply Chain Management (FSCM)",
  description: "Comprehensive training on Maintenance Management, Work Order Processing, Crew Scheduling, IT Asset Management, Financial Integrations, and PeopleTools skills within the FSCM framework.",
  duration: "4 Months",
  className: "financialsSupplyChainManagement", // Added for specific styling if needed
  icon: faTruck,
  fee: 50000,
  prerequisites: [
    "Basic understanding of enterprise resource planning (ERP) systems",
    "Familiarity with maintenance and financial processes is beneficial"
  ],
  content: [
    "Maintenance Management Module Overview",
    "Business Processes",
    "Employee Self Service-Request",
    "Maintenance Management System Parameters",
    "Work Order Processing",
    "Crew Scheduling Processing",
    "Chargeback and Capitalization Inquiry",
    "Configuring Batch Processes",
    "Delivered Workflows and Reports",
    "IT Asset Management",
    "Financial Integration to General Ledger (GL)",
    "WorkCenters and 9.2 Highlights",
    "Integration with Project Costing (PC), eProcurement (ePro), Asset Management (AM)",
    "PeopleTools Skills for Maintenance Management",
    "Additional Topics: Auto Assignment, Inspections, Projections, Integrations, Reports"
  ],
  toolsCovered: [
    "PeopleSoft Maintenance Management",
    "PeopleSoft Asset Management",
    "PeopleSoft Project Costing",
    "PeopleSoft Purchasing",
    "PeopleSoft Inventory",
    "PeopleSoft Resource Management",
    "PeopleTools",
    "BI Publisher",
    "Pivot Grid Reporting"
  ],
  targetAudience: "Professionals seeking to enhance their expertise in maintenance management, financial integrations, and supply chain processes within enterprise systems."
},
digitalMarketing: {
  name: "Digital Marketing",
  description: "A comprehensive program covering all aspects of digital marketing including Web Design, SEO, SEM, Social Media Marketing, Email Campaigns, Analytics, and Reputation Management.",
  duration: "3 Months",
  fee: 45000,
  icon: faBullhorn,
  className: "digitalMarketing",
  prerequisites: [
    "Basic computer literacy",
    "Familiarity with social media platforms",
    "No prior marketing experience required"
  ],
  content: [
    "Module 1: Web Design with WordPress",
    "Domain & Hosting Setup",
    "WordPress Installation & Configuration",
    "Theme Customization with Elementor",
    "Header/Footer Setup & Google Map Integration",
    "Lead Generation Forms & Blog Setup",
    
    "Module 2: Search Engine Optimization (SEO)",
    "SEO Fundamentals & Search Engine Working",
    "Keyword Research & Competitor Analysis",
    "On-page Optimization (URLs, Meta Tags, Content)",
    "Technical SEO (robots.txt, sitemaps, redirects)",
    "Off-page Strategies (Backlinks, Submissions)",
    "Google Search Console Implementation",
    "SEO Tools & Reporting",
    
    "Module 3: Google Ads & SEM",
    "Account Creation & Structure",
    "Campaign Types (Search, Display, Video, Shopping)",
    "Advanced Targeting (Audiences, Demographics)",
    "Ad Creation & Extensions",
    "Conversion Tracking & Remarketing",
    "Performance Analysis & Reporting",
    
    "Module 4: Social Media Marketing",
    "Facebook/Instagram Business Setup",
    "Content Strategies & Calendar Planning",
    "Organic Growth Techniques",
    "Paid Advertising (Campaign Setup, Targeting)",
    "Twitter & LinkedIn Marketing",
    "YouTube Channel Management & Video SEO",
    
    "Module 5: Email Marketing",
    "List Building & Management",
    "Mailchimp Campaign Creation",
    "Template Design & Spam Control",
    "Performance Tracking",
    
    "Module 6: Analytics & ORM",
    "Google Analytics Implementation",
    "Traffic Source Analysis",
    "Online Reputation Monitoring",
    "Review Management",
    
    "Module 7: Specialized Marketing",
    "Affiliate Marketing Strategies",
    "Amazon Affiliate Program",
    "Google Business Profile Optimization",
    "Local SEO Techniques",
    
    "Module 8: Practical Projects",
    "Complete Website Development",
    "SEO Implementation Project",
    "Paid Campaign Execution",
    "Social Media Strategy Development"
  ],
  toolsCovered: [
    "WordPress", "Elementor", "Google Search Console", 
    "Google Ads", "Meta Business Suite", "Mailchimp",
    "Google Analytics", "SEMrush", "Yoast SEO",
    "Screaming Frog", "Ahrefs", "Canva",
    "Google My Business", "Google Tag Manager"
  ],
  
  targetAudience: "Marketing professionals, business owners, career switchers, and graduates seeking comprehensive digital marketing skills. Ideal for those wanting to master both strategic and technical aspects of digital marketing."
},
abap: {
  name: "SAP ABAP Programming",
  description:
    "A hands-on training program in SAP ABAP focusing on core development concepts, data dictionary, reporting, module pool programming, forms, cross-applications, and mini projects.",
  duration: "2 Months",
  fee: 35000,
  icon: faNetworkWired,
  className: "abap",
  prerequisites: [
    "Basic programming knowledge",
    "Understanding of ERP concepts is helpful but not mandatory"
  ],
  content: [
    "Module I: Basics (10 days)",
    "Language Principles",
    "Data Types",
    "Structure Data Objects",
    "Types & Type-Pools",
    "Loops & Strings",
    "Modularization Techniques (Includes, Subroutines, Function Modules, Macros)",
    "Tables, Internal Tables & Joins",

    "Module II: Data Dictionary (3 days)",
    "Tables, Structures, Views",
    "Search Help & Lock Objects",

    "Module III: Reporting (5 days)",
    "Classical Reports",
    "Interactive Reports",
    "Logical Database Reports",
    "SAP Query Reports",
    "ABAP List Viewer / ALV",

    "Module IV: Module Pool Programming (5 days)",
    "Radio Buttons",
    "Sub-screen Area Control",
    "Tab-strip Control",
    "Table View Control",
    "Step Loops",

    "Module V: Scripts (3 days)",
    "SAP Script Forms",

    "Module VI: SmartForms (2 days)",

    "Module VII: Batch Data Communication (3 days)",
    "Direct Input, Call Transaction, Session Method",

    "Module VIII: Advanced Topics (5 days)",
    "BAPI, BADI, Enhancements, LSMW",
    "ABAP Objects, Workflow Intro, Web Dynpro",

    "Module IX: Cross Applications (5 days)",
    "ALE, RFC, EDI, IDOCS",

    "Mini Project (15 days)",

    "Additional Topics (2 days)",
    "Debugging, Runtime Analysis, SQL Trace",
    "Data Sets, Field Symbols, Text Elements"
  ],
  toolsCovered: [
    "SAP GUI", "SE80", "SE38", "SE11", "SE93", "SmartForms",
    "SAP Script", "LSMW", "ABAP Debugger", "ALV", "IDOC Viewer"
  ],
  targetAudience:
    "Aspiring SAP technical consultants, developers, and professionals seeking deep knowledge in SAP ABAP programming and enterprise integration."
},abapOnHana: {
  name: "ABAP on HANA",
  description: "Comprehensive training covering ABAP development optimized for the HANA platform, including SQL basics, CDS Views, AMDP, ADBC, and performance tuning tools.",
  duration: "35-40 Hours",
  fee: 55000,
  icon: faTerminal, // (or pick any appropriate icon if you want)
  className: "abapOnHana",
  prerequisites: [
    "Basic ABAP knowledge",
    "Familiarity with database concepts",
    "No prior HANA experience required"
  ],
  content: [
    "Chapter 1: ABAP on HANA Introduction and SAP Components",
    
    "Chapter 2: SQL Basics for HANA",
    "Basic Concepts of SQL",
    "Fetching Data from Tables/Views",
    "Retrieving Data from Multiple Tables",
    "Data Aggregation",
    "Modification of Data",
    "Data Storage Techniques",
    "Accessing Data using Views",
    "Database Transactions",
    "SQL Clause New Features",
    "SQL Functions",
    "Using Tuple Variables",
    "Case Statements",
    "Group By, Order By",
    "IS NULL/NOT NULL, BETWEEN, LIKE Predicate",
    "Order Precedence",
    "Aggregate Functions",
    "UNION and UNION ALL",
    "Joining Tables: Inner Join, Left Outer Join, Right Outer Join, Full Outer Join",
    "Data Manipulation: Insert, Update, Delete",
    "Data Definition: Create Column Table, Alter Table, Rename Table",
    
    "Chapter 3: ABAP on HANA Application Development",
    "New Technical Options",
    "Code Push Down Concepts",
    "Impact on Database",
    "ALV IDA Reporting",
    
    "Chapter 4: Views on HANA",
    "Attribute Views, Analytical Views, Calculation Views",
    "SAP HANA Views in ABAP",
    "Code-to-Data Paradigm",
    "Native SQL Approach",
    "Accessing HANA Views in External Views (DDIC)",
    
    "Chapter 5: ADBC (ABAP Database Connectivity)",
    
    "Chapter 6: CDS Views (Core Data Services)",
    "View Definitions using CDS",
    "Open SQL Usage",
    "ABAP Language Enhancements",
    "CDS Implementations",
    "Creation of CDS Views",
    "CDS View on View",
    "CDS Views with Input Parameters",
    "CDS Views Associations",
    "Filtered Associations",
    "CDS Annotations",
    
    "Chapter 7: AMDP (ABAP Managed Database Procedures)",
    "Database Procedures in ABAP",
    "SAP DB Procedures",
    "Creation of AMDP",
    
    "Chapter 8: Eclipse HANA Studio",
    
    "Chapter 9: ADT (ABAP Development Tools)",
    
    "Chapter 10: Performance Tools & OO ABAP Concepts",
    "Runtime Analysis (SE30)",
    "ABAP Trace (SAT)",
    "Code Inspector (SCI)",
    "SQL Trace (ST05)",
    "SQLM and SWLT",
    "Object Oriented ABAP (OOABAP) Concepts",
    "Visibility (Public/Protected/Private)",
    "Static/Instance Variables and Methods",
    "Inheritance, Abstract Classes/Methods",
    "Interfaces and Method Overriding",
    "Polymorphism",
    
    "Chapter 11: Transportation, Lifecycle Management, CTS and Miscellaneous Topics"
  ],
  toolsCovered: [
    "Eclipse IDE", "HANA Studio", "ADT (ABAP Development Tools)", 
    "SE30", "SAT", "SCI", "ST05", "SQLM", "SWLT",
    "SAP HANA Database", "SQL Console", "SE11", "SE80"
  ],
  targetAudience: "ABAP developers, SAP consultants, technical architects aiming to enhance ABAP programming on HANA database environment with optimized performance and new capabilities."
},
s4HanaFinance: {
  name: "SAP FICO & S4 Hana Simple Finance",
  description: "Covers SAP FICO & S/4 HANA Finance, including General Ledger, Payables, Receivables, Asset Accounting, Costing, Reporting, and more.",
  duration: "40-45 Hours",
  fee: 50000,
  className: "s4HanaFinance",
  icon: faWallet, // Font Awesome icon
  prerequisites: [
    "Basic understanding of accounting or finance processes",
    "No prior SAP experience required (helpful but not mandatory)"
  ],
  content: [
    // Section 1: Introduction & Master Data
    "Introduction to SAP S/4HANA Finance",
    "HANA Architecture & Deployment",
    "Journey to SAP S/4HANA with the Activate Methodology",
    "Organization Structure (self-learning)",
    "Master Records (self-learning)",

    // General Ledger Accounting
    "General Ledger Accounting",
    "New General Ledger Accounting (Universal Journal)",
    "Classic GL vs New GL Accounting",
    "Account Groups & Reconciliation Accounts",
    "Document Types, Posting Keys, and Account Assignment Models",
    "G/L integration with MM and SD",
    "G/L Reports",

    // Accounts Payable & Accounts Receivable
    "Accounts Payable (P2P)",
    "Accounts Receivable (O2C)",
    "Business Partners & Customer Master",
    "Vendor Master & Asset Master",
    "Automatic Payment Program",
    "Dunning Process",
    "Down Payments, Bills of Exchange & Guarantees",

    // Section 2: Asset Accounting
    "Asset Accounting Overview",
    "Asset Master Data",
    "Depreciation Areas & Methods",
    "Asset Acquisition & Retirement",
    "Asset Transfer & Reporting",
    "Integration with General Ledger",

    // Section 3: Controlling & Profitability
    "CO-Controlling Overview",
    "Cost Center Accounting",
    "Internal Order Accounting",
    "Profitability Analysis (CO-PA)",
    "Product Cost Planning",
    "Reports for Controlling",

    // Section 4: Global Parameters & Financial Statements
    "Global Parameters (Company Code, Fiscal Year Variant, COA)",
    "Posting Period Variants & Period Closure",
    "Financial Statement Version",
    "Foreign Currency Transactions & Exchange Rate Maintenance",
    "Financial Reporting (Balance Sheet, P&L, Trial Balance)",
    "Vendor and Customer Reports",

    // Section 5: Migration to S/4HANA
    "Migrating to Universal Journal",
    "Preparing for Migration (Material Ledger, House Bank Accounts)",
    "Post Processing and Migration Challenges",
    "Configuring Financials in SAP S/4HANA",

    // Section 6: SAP Fiori & New Concepts
    "Introduction to SAP Fiori",
    "Customizing SAP Fiori for Financials",
    "Cost Elements in S/4HANA Finance",
    "Configuring Asset Accounting in S/4HANA",
    "New Features in Management Accounting",

    // Additional Topics
    "SAP S/4HANA Financial Integration with Other Modules",
    "Taxation (VAT and Withholding Taxes)",
    "Cross-Module Integration (MM, SD, PP)"
  ],
  toolsCovered: [
    "SAP GUI", "SAP Fiori", "SAP S/4HANA", "New GL", "SAP Business Partner", "Automatic Payment Program", "SAP FICO Transaction Codes"
  ],
  targetAudience: "Finance professionals, SAP consultants, accountants, and anyone aiming to pursue a career in SAP Financials & Controlling."
},
sapS4HanaMm: {
  name: "SAP MM (Materials Management) – S/4HANA",
  description: "Covers SAP S/4HANA Materials Management, including ERP basics, procurement, inventory, pricing, and module integration.",
  className: "sapS4HanaMm",
  icon: faCubes, // Choose a relevant Font Awesome icon
  fee: 40000,
  duration: "10 weeks",
  prerequisites: [
    "Basic understanding of business processes",
    "Familiarity with ERP concepts",
    "Knowledge of procurement or inventory is a plus"
  ],
  content: [
    "Module 1: Introduction to ERP and SAP S/4HANA",
    "Overview of ERP Packages",
    "Introduction to SAP S/4 1809",
    "MM Module Objectives",
    "SAP Navigation & Fiori Overview",

    "Module 2: Organizational Structure in SAP",
    "Company, Company Code, Plant, Storage Location",
    "Purchase Organization and Group",

    "Module 3: Master Data Management",
    "Material Master, Vendor Master",
    "BP, Purchase Info Record",
    "Source Determination and Quota Arrangement",

    "Module 4: Procurement Process",
    "Purchase Requisition and Purchase Order",
    "Request for Quotation, Contracts and Schedule Agreements",
    "Document Types and Number Ranges",

    "Module 5: Release Procedures",
    "Release Strategy for PR, PO, RFQ, Contracts",

    "Module 6: Pricing Procedure",
    "Condition Tables, Access Sequence, Condition Types",
    "Calculation Schema and Schema Groups",

    "Module 7: External Services Management",
    "Service Master, Service PO, Entry Sheet",

    "Module 8: Inventory Management",
    "Movement Types, Goods Receipt and Issue",
    "Transfer Postings, Reservations, Stock Balances",

    "Module 9: Physical Inventory",
    "Inventory Types, Count, Differences Posting",

    "Module 10: Special Stocks & Procurement",
    "Consignment, Subcontracting, Stock Transport Orders",

    "Module 11: Invoice Verification",
    "Basic & Advanced Scenarios, GR/IR, Credit Memos, Blocking, ERS",

    "Module 12: Integration with Other Modules",
    "Integration with FI/CO, SD, PP, QM, PM",
    "Automatic Account Determination",

    "Module 13: Data Migration",
    "LSMW, LTMC, LTMOM",

    "Module 14: Material Valuation",
    "Price Control, Split Valuation, Global & Local Configuration"
  ],
  toolsCovered: [
    "SAP S/4HANA", "Fiori", "SAP GUI", "MM Module", 
    "LSMW", "LTMC", "SAP SD", "SAP FI/CO", "SAP PP"
  ],
  targetAudience: "Aspiring SAP MM Consultants, Supply Chain Professionals, Procurement Specialists, and IT professionals aiming to understand S/4HANA Materials Management."
}
,
successFactors: {
  name: "SAP SuccessFactors",
  description: "End-to-end training on SAP SuccessFactors including instance setup, employee central, goal & performance management, integration, and analytics.",
  duration: "40-45 Hours",
  fee: 45000,
  className: "successFactors",
  icon: faUsers, // Replace with appropriate Font Awesome icon
  prerequisites: [
    "Basic understanding of HR processes",
    "No prior SAP experience required"
  ],
  content: [
    // Week 1: Introduction
    "Why Cloud? Why SuccessFactors?",
    "SuccessFactors Core & Talent Management Overview",
    "Role of Professional Services Consultant",
    "BizX Methodology, Accelerators, Configuration Workbooks",
    "SuccessFactors Architecture & Business Execution Process",
    "Terminologies, Instance, Provisioning, Useful Links",
    "Home Page, Portlets, Dashboards, Tile Browser",
    "Welcome Menu, Favorites, Search Functionality",

    // Week 2: Mastery
    "Personalizing Instance - Portlets, Logo, Themes, Notifications",
    "Organization Chart, Directory, Resources, Personal Card",
    "Position Org Chart - Add/Edit Positions, Internal Numbers",
    "Advanced Position Management, CSV File Handling",

    // Week 3: Employee Central
    "Corporate & Succession Data Models",
    "Foundational Objects Configuration",
    "Generic Objects, Cost Center, Workflows",
    "Proxy Management, Hire Process, Workflow Monitoring",
    "Employee Self Service, Manager Self Service, Data Changes",

    // Week 4: Permissions & Time Management
    "Role-Based Permissions (RBP), Groups, Security",
    "XML, DTD Files, Rules",
    "Meta Data Framework (MDF), Cost Centers, Config UI",
    "Picklist, Propagation Rules, Payroll Overview",
    "Time Off Setup - Calendar, Schedule, Time Profiles",

    // Week 5: Goal & Performance Management
    "Goal Management - Templates, SMART, Cascading",
    "Performance Management - Forms, Reviews, Competencies",
    "Route Map, Rating Scale, Stack Ranker",
    "360 Review, Calibration, Compensation Overview",

    // Week 6: Miscellaneous
    "Analytics - Standard & Ad-Hoc Reports",
    "SuccessFactors JAM & Mobile Setup",
    "Integration - Cloud/Hybrid Deployments",
    "Resume Preparation, Interview FAQs, Open Q&A"
  ],
  toolsCovered: [
    "SuccessFactors Instance", "Provisioning", "BizXpert", "SAP JAM", "SuccessFactors Mobile", "Employee Central", "MDF", "XML Pad"
  ],
  targetAudience: "HR professionals, SAP consultants, and anyone aspiring to work in cloud-based HCM solutions."
},
sapGrc: {
  name: "SAP GRC Access Control 10.1",
  description: "Covers SAP GRC 10.1 with Access Risk Analysis, Emergency Access, Role & Request Management, and Workflow Configuration.",
  duration: "40-45 Hours",
  fee: 40000, // Adjust fee as needed
  className: "sapGrc",
  icon: faShieldAlt, // Replace with an appropriate Font Awesome icon
  prerequisites: [
    "Basic understanding of SAP security concepts",
    "No prior GRC experience required"
  ],
  content: [
    // Overview and Installation
    "Overview of SOX, SOD, and GRC 10.1",
    "Difference between GRC 5.3 and GRC 10.1",
    "Applications and Components of GRC AC",
    "Prerequisites, Installation, and Configuration of GRC 10.1",
    "Access Control 10.1 Architecture Overview",

    // Security and Authorizations
    "Object-Level Security and Authorization Requirements",
    "Access Control Delivered Roles",
    "Shared Configuration Settings",
    "Integration Framework Configuration",
    "Business Configuration (BC) Sets",
    "Synchronizing Access Control Repository",

    // Access Risk Analysis (ARA)
    "Rule Set Creation and Business Process Setup",
    "Functions and SoD Risk Creation",
    "Critical Role, Profile, Action, and Permission Setup",
    "Risk Analysis at User, Role, and Profile Levels",
    "Mitigation and Remediation Processes",
    "Simulation for Risk Analysis",
    "Control ID Creation and Assignment",

    // Emergency Access Management (EAM)
    "Managing and Planning Emergency Access",
    "EAM Configuration - Centralized and Decentralized",
    "Creating Firefighter IDs, Controllers, Owners",
    "Maintaining Reason Codes and FFID Assignments",
    "Performing Emergency Activities and Log Synchronization",

    // Business Role Management (BRM)
    "Business Role Management Configuration",
    "Business Role Methodology and Condition Groups",
    "Role Creation, Ownership, and Mass Maintenance",
    "Role Import, Update, Comparison, and Mining",

    // Access Request Management (ARM)
    "Provisioning Configurations and EUP Settings",
    "Configuring Approvers and Managers",
    "Access Request Creation - Templates and Model Users",
    "Admin Delegation and Emergency Access Request Handling",
    "Access Request Approval and Processing",

    // MSMP Workflow and Business Rule Framework (BRF+)
    "MSMP Workflow Introduction and Setup",
    "Cost Center Hierarchy Configuration",
    "Automatic Workflow Customization",
    "Process IDs, BRF+ Applications, and Rules (Initiator, Agent, Routing, Notification)",
    "Mapping BRF+ Rules to Standard Process IDs",
    "Background Jobs in GRC AC"
  ],
  toolsCovered: [
    "GRC 10.1 Access Control", "Access Risk Analysis (ARA)", "Emergency Access Management (EAM)", "Business Role Management (BRM)", "Access Request Management (ARM)", "MSMP Workflow", "BRF+"
  ],
  targetAudience: "SAP security consultants, auditors, risk managers, and professionals aiming to specialize in SAP Governance, Risk, and Compliance."
},
sapHcm: {
  name: "SAP HCM (Human Capital Management)",
  description: "Comprehensive training in SAP HCM covering organizational management, recruitment, payroll, time management, enterprise structure, master data, and integration with other SAP modules.",
  duration: "40-45 Hours",
  fee: 40000, // Update fee if needed
  className: "sapHcm",
  icon: faUserCog, // Replace with a suitable Font Awesome icon
  prerequisites: [
    "Basic knowledge of HR processes",
    "No prior SAP experience required"
  ],
  content: [
    // Overview
    "SAP Overview, ERP Concepts, ASAP Methodology",
    "R/3 Structure, System Landscape",
    "HR Module Overview, Organizational & Employee Information",

    // Recruitment and Personnel Development
    "Recruitment Cycle, Training and Events",
    "Personnel Development, Profile Matching (Hands-on)",

    // Employee Benefits and Cost Management
    "Benefits Processing and Enrollment (Hands-on)",
    "Personnel Cost Planning, Compensation Management",

    // Time Management
    "Time Management Overview, Travel Management",
    "Holiday Calendar, Work Schedules, Rules and Variants",
    "Selection Rules, Absences and Attendances",
    "Time Evaluation, Overtime Calculation",

    // Payroll Management
    "Wage Type Configuration, Pay-scale Structure",
    "Basic Pay (IT0008), Recurring Payments (IT0014)",
    "Additional Payments (IT0015)",
    "Payroll Schemas and PCRs",
    "Processing and Evaluation, Classes and Garnishments",
    "Payroll Periods, Control Record, Retro Functionality",
    "FI Integration",

    // Organizational Management
    "Expert Mode, Simple Maintenance",
    "Organizational Staffing, OM Actions, Number Ranges",
    "OM Relationships, Info-type Configurations",
    "Evaluation Paths, PA & OM Integration",
    "Custom Objects and Relationships, General Structures",

    // Reporting and Information Display
    "HR Reports and Queries, Creating Ad-hoc Query (Hands-on)",

    // Configuring Organizational Structure
    "Creating Objects, Relationships, Descriptions",
    "Department/Staff Setup, Plan Data Maintenance",
    "Account Assignment to Org Unit, Structure Maintenance",

    // Configuring Postings
    "Position Configuration, Reporting Relationships",
    "Organizational Structure Reporting",

    // Personnel Actions
    "Hiring an Employee, Changing Master Data",
    "Org Structure Reporting for Employees",

    // Enterprise Structure
    "Personnel Area/Sub Area, Employee Group/Subgroup",
    "Organizational Assignments and Maintenance",

    // Features and Decision Trees
    "Display Features, Feature Decision Trees",

    // Planned Working Time and Basic Pay Connection
    "HR Master Data, Work Schedules Overview",
    "Primary Wage Types and Employee Groups",

    // Pay Scale Structures
    "Customizing Project Administration",
    "Tariff Feature Decision Trees",
    "Pay-scale Period Parameter Setup",
    "Work Area Determination, Basic Pay Setup",

    // Wage Types and Indirect Valuation
    "Dialog Wage Types, Wage Type Assignment Controls",
    "Indirect Valuation Setup",

    // Pay Scale Reclassification and Pay Increases
    "Performing Reclassifications to New Pay Levels",
    "Executing Standard Pay Increases",

    // Master Data Configuration
    "LSMW, BDC Usage",
    "Modifying Organizational Structure (New Units & Positions)",
    "Hiring with Configured Sub Areas, Employee Groups"
  ],
  toolsCovered: [
    "SAP HCM", "PA30", "OM", "Time Evaluation Tools", "Payroll Schema Editor", "LSMW", "BDC", "Ad-hoc Query"
  ],
  targetAudience: "HR professionals, functional consultants, and beginners aiming to work in SAP HR implementations or support."
},
sapSecurity: {
  name: 'SAP Security',
  description: 'Learn the fundamentals and advanced features of SAP Security including user and role administration, audit tools, client copy methods, and transport management.',
  duration: '6 Weeks',
  fee: 12000,
  className: 'sapSecurity',
  icon: faUserSecret,
  prerequisites: [
    'Basic knowledge of SAP ERP',
    'Familiarity with IT security concepts',
  ],
  content: [
    'Introduction to SAP ERP',
    'Overview of SAP ABAP Course',
    'SAP modules at a Glance',
    'Restriction at Object Level in PFCG Roles',
    'Securing User and Group Administration',
    'Adding Missing Authorization Objects',
    'System Trace and SU53',
    'Creating and Assigning Users to Roles',
    'Transporting User Master Records',
    'Transporting Single Roles',
    'Transporting Mass Roles',
    'Use of PFCG_TIME_DEPENDENCY',
    'Use of User Groups in Security',
    'Overview of R/3 Client',
    'Client Copy Requirements and Process',
    'Establishing RFC Communications',
    'Creating and Assigning Logical Systems to Clients',
    'Loading USOBX_C and USOBT_C Tables',
    'Initial Copy of SAP Defaults into SU25',
    'Linking SU25, SU24 and PFCG',
    'Using SE16N, SE38, S_TABU_DIS, SM30',
    'Useful Tables for Security',
    'User of SAP_ALL and SAP_NEW (Audit)',
    'SAP Basis Security Audit Tools',
    'Reading and Configuring the Audit Log',
    'Deleting Roles and Use of SAP* and DDIC',
    'Transporting Roles with USR*, AGR*, USH* Tables',
    'Security Profile Parameters',
    'Evaluation Reports (rsusr002 - rsusr102, etc.)'
  ],
  targetAudience: 'System administrators, SAP security consultants, and IT professionals aiming to manage SAP user and role security efficiently.',

},sapSd: {
  name: 'SAP SD',
  description: 'Master the SAP Sales and Distribution (SD) module, covering everything from organizational structure, master data, sales processes, pricing, and integration with finance and logistics.',
  duration: '8 Weeks',
  fee: 15000,
  className: 'sapSd',
  icon: faShareAltSquare,
  prerequisites: [
    'Basic understanding of business processes in sales and logistics',
    'Familiarity with SAP ERP is helpful'
  ],
  content: [
    'Introduction to SAP ERP',
    'SAP Architecture & Landscape',
    'Enterprise Structure in Sales and Distribution',
    'Define and Assign Organizational Elements',
    'Account Group, Number Range & Assignment',
    'Customer Master Data',
    'Material Master Data',
    'Customer Material Info Record',
    'Condition Records',
    'Sales Order Process: Inquiry, Quotation, Order',
    'Shipping & Delivery Process',
    'Billing & Invoice Handling',
    'Free of Charge Delivery, Cash Sales, Rush Order Process',
    'Sales Service & Complaints Handling',
    'Return Order, Credit Memo, Debit Memo Request',
    'Invoice Correction, Free of Charge Subsequent Delivery',
    'Sales Document Types, Structure, and Copy Controls',
    'Delivery and Billing Document Types',
    'Pricing Configuration: Condition Types, Tables, Access Sequence',
    'Pricing Procedure Determination and Reporting',
    'Discounts, Freight, Rebate, Condition Exclusion Groups',
    'Taxes, Item Proposals, Free Goods',
    'Incompletion Procedure, Listing/Exclusion',
    'Material Determination, Output Determination',
    'Item Category & Schedule Line Determination',
    'Shipping Point & Picking Location Determination',
    'Availability Check, Transfer of Requirements',
    'Forward & Backward Scheduling',
    'Credit Management and Revenue Account Determination',
    'Shipping Conditions, PGI, Route Determination',
    'Billing Plans and Integration with Finance',
    'Rebate Processing and Special Billing Scenarios',
    'Stock Posting, Transfers, and Third-Party Sales',
    'Individual Purchase Orders and MTO/MTS',
    'Consignment Orders and Inter-Company Sales',
    'Contracts & Scheduling Agreements (Outline Agreements)'
  ],
  targetAudience: 'Sales consultants, logistics professionals, and SAP beginners looking to specialize in the Sales and Distribution module.',

},
sapMm: {
  name: "SAP MM (Materials Management)",
  description: "Covers SAP MM with focus on procurement, inventory, vendor management, and integration with other modules.",
  className: "sapMm",
  icon: faBoxes, // Replace with a suitable Font Awesome icon
  fee: 35000,
  duration: "8 weeks",
  prerequisites: [
    "Basic knowledge of procurement and inventory",
    "Interest in enterprise resource planning systems",
    "No prior SAP experience required"
  ],
  content: [
    "Module 1: ERP and SAP Introduction",
    "ERP Packages, SAP Overview",
    "Objectives of Materials Management",

    "Module 2: SAP Navigation",
    "Logins, Sessions, Screens, Navigation Features",

    "Module 3: Organizational Structure",
    "Company, Company Code, Plant, Storage Location",
    "Purchase Org and Group",

    "Module 4: Master Data",
    "Material Master, Vendor Master",
    "Number Ranges, One Time Vendor Setup",
    "Purchase Info Record",

    "Module 5: Source Determination",
    "Source List, Quota Arrangement",

    "Module 6: Purchasing",
    "PR, PO, RFQ, Outline Agreements",
    "Contract Types, Schedule Agreement",
    "Service PO, Price Comparison",

    "Module 7: Release Procedures",
    "Release Strategies for PR, PO, RFQ",

    "Module 8: Pricing Procedures",
    "Condition Types, Access Sequence, Calculation Schema",

    "Module 9: External Services Management",
    "Service Master, Entry Sheet, PO",

    "Module 10: Optimized Purchasing",
    "Automatic PO from PR, Automatic PO at GR",

    "Module 11: Inventory Management",
    "Movement Types, GR, GI, Reservations",
    "Transfer Postings (One-Step & Two-Step)",

    "Module 12: Physical Inventory",
    "Types, Document Creation",

    "Module 13: Special Stocks and Procurement",
    "Consignment, Subcontracting, Stock Transport Orders",

    "Module 14: Material Valuation",
    "Standard vs Moving Price, Split Valuation",
    "Global/Local Configurations",

    "Module 15: Integration with Other Modules",
    "MM-FICO, MM-SD, MM-PP, PM-MM, QM-MM"
  ],
  toolsCovered: [
    "SAP ECC", "SAP GUI", "MM Module", 
    "Pricing Procedure Tools", "Vendor Management", 
    "SAP Integration Framework"
  ],
  targetAudience: "Procurement managers, supply chain professionals, fresh graduates, and SAP beginners interested in materials management using SAP."
}


};

export default courses;
